import React from 'react';
import { Modal, Button, Form } from 'react-bootstrap';

/**
 * Modal for bulk editing multiple songs' roles
 * 
 * @param {boolean} show - Whether to show the modal
 * @param {function} onHide - Function to call when hiding the modal
 * @param {number} count - Number of selected songs
 * @param {string} role - Current role value
 * @param {function} setRole - Function to update role value
 * @param {function} onSave - Function to call when saving the roles
 * @returns {JSX.Element} Modal component
 */
const BulkEditRoleModal = ({ 
  show, 
  onHide, 
  count, 
  role, 
  setRole, 
  onSave 
}) => (
  <Modal show={show} onHide={onHide} centered>
    <Modal.Header closeButton>
      <Modal.Title>
        Uredi vloge izbranih pesmi
      </Modal.Title>
    </Modal.Header>
    <Modal.Body>
      <Form.Group>
        <Form.Label>Število izbranih pesmi</Form.Label>
        <Form.Control
          type="text"
          value={count}
          disabled
          className="mb-3"
        />
        
        <Form.Label>Nova vloga pesmi</Form.Label>
        <Form.Control
          type="text"
          value={role}
          onChange={(e) => setRole(e.target.value)}
          placeholder="Vstopna, Psalm, Povzdig, Obhajilna, itd."
        />
        <Form.Text className="text-muted">
          Vnesite vlogo pesmi, npr. Vstopna, Psalm, Aleluja, itd.
        </Form.Text>
      </Form.Group>
    </Modal.Body>
    <Modal.Footer>
      <Button variant="secondary" onClick={onHide}>
        Prekliči
      </Button>
      <Button 
        variant="primary" 
        onClick={onSave}
      >
        Shrani
      </Button>
    </Modal.Footer>
  </Modal>
);

export default BulkEditRoleModal;